module.exports = __webpack_public_path__ + "static/media/webdesign-services-img16.82de9bfd.jpg";